import React from "react";
import { ButtonMob } from "../../../utils/utils";

const ModalInfoPreValuations = ({
  onCancel,
  onConfirm,
  children,
  loader,
  buttonConfirm,
  buttonConfirmText = "Confirmar",
  buttonCancelText = "Cerrar",
  buttonsWidth = "50%",
  maxWidth = "25rem",
}) => {
  const styleModal = {
    display: "flex",
    position: "fixed",
    zIndex: 999,
    whiteSpace: "pre-line",
    maxWidth: maxWidth,
  };
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    zIndex: 1000,
  };

  return (
    <div style={overlayStyle} className="w-100">
      <div
        className="popUpServices justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "3% 10%",
          }}
        >
          {/* <div
          style={{
            position: "absolute",
            top: "5%",
            right: "5%",
            fontWeight: "bold",
            fontSize: "1.5rem",
            color: " #9DACBD",
            cursor: "pointer",
          }}
          onClick={onCancel}
        >
          <i className="bi bi-x-circle"></i>
        </div> */}

          <div
            className="pt-3 my-2 mx-auto"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            {children} {/* Aquí se renderizan los children */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalInfoPreValuations;
